<script lang="ts">
	// App screenshot that follows the site theme. Captures ship in both app
	// appearances (dark is canonical, `-light` variants beside them), and the
	// pair swaps on mode-watcher's `.dark` class — a <picture> media query
	// would only track the OS setting, not the site's theme toggle.
	let {
		dark,
		light,
		alt,
		width,
		height,
		class: klass = ''
	}: {
		dark: string;
		light?: string;
		alt: string;
		width?: number;
		height?: number;
		class?: string;
	} = $props();
</script>

{#if light}
	<img src={light} {alt} {width} {height} class="{klass} dark:hidden" loading="lazy" />
	<img src={dark} {alt} {width} {height} class="hidden {klass} dark:block" loading="lazy" />
{:else}
	<img src={dark} {alt} {width} {height} class={klass} loading="lazy" />
{/if}
